import { Button, Tooltip } from '@mui/material';

export const AddButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  return (
    <Tooltip title={disabled ? undefined : 'Add'}>
      <span>
        <Button
          className='!min-w-[20px] p-[6px]'
          variant='contained'
          disabled={disabled}
          onClick={onClick}
        >
          <i className='material-symbols-add-rounded w-[20px] h-[20px]' />
        </Button>
      </span>
    </Tooltip>
  );
};
